import React from 'react';
import { Volume, VolumeOff } from 'tabler-icons-react';
import { useAudio } from '../context/AudioContext';
import Tooltip from './Tooltip';

interface SoundToggleProps {
  onClick?: () => void;
}

const SoundToggle: React.FC<SoundToggleProps> = ({ onClick }) => {
  const { isSoundEnabled, toggleSound, isSoundButtonDisabled } = useAudio();

  const handleClick = () => {
    if (isSoundButtonDisabled) return;

    toggleSound();
    if (onClick) onClick();
  };

  return (
    <Tooltip
      content={isSoundEnabled ? 'Desactivar Sons' : 'Activar Sons'}
      position="left"
    >
      <button
        onClick={handleClick}
        className={`icon-bg relative overflow-hidden audio-control-button ${
          isSoundButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        title={isSoundEnabled ? 'Desactivar Sons' : 'Activar Sons'}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className={`absolute transition-all duration-300 ease-in-out transform ${
              isSoundEnabled
                ? 'opacity-100 rotate-0 scale-100'
                : 'opacity-0 -rotate-90 scale-50'
            }`}
          >
            <Volume className="text-white w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 lg:w-9 lg:h-9" />
          </div>
          <div
            className={`absolute transition-all duration-300 ease-in-out transform ${
              !isSoundEnabled
                ? 'opacity-100 rotate-0 scale-100'
                : 'opacity-0 rotate-90 scale-50'
            }`}
          >
            <VolumeOff className="text-white w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 lg:w-9 lg:h-9" />
          </div>
        </div>
      </button>
    </Tooltip>
  );
};

export default SoundToggle;
